// extracted by mini-css-extract-plugin
export default {"menuBlock":"CD-z","title":"DD-z","nav":"ED-z","flexCell":"FD-z","facetLink":"GD-z"};